import { useState, useEffect } from 'react';
import axios, { AxiosRequestConfig } from 'axios';
import styles from './styles.module.scss';
import { Board } from '../../components/Board';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/pt';
import { Loading } from '../../components/Loading';
import moment from 'moment';
import { hasPermission, verifyRoutePermissions } from '../../globalFunctions';
import { useNavigate } from 'react-router-dom';
import { NavButton } from '../../components/NavButton';
import { User } from '../../types';

interface Question {
    id: number;
    desc: string;
    img: string;
    correctOption: number;
}

export const ComputacionalThinkingQuiz = () => {
    const [questions, setQuestions] = useState<Question[]>([]);
    const [fromDate, setFromDate] = useState<any>(null);
    const [answers, setAnswers] = useState<{ [key: number]: number }>({});
    const [submitting, setSubmitting] = useState(false);
    const [user, setUser] = useState<any>();
    const [config, setConfig] = useState({ desc: '', logo: '' });
    const [idTeste, setIdTeste] = useState()
    const [schoolType, setSchoolType] = useState('1')

    const navigate = useNavigate();
    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
            navigate
        );
        setUser(user);
    }, []);
    // Carregar questões ao iniciar
    useEffect(() => {
        fetchQuestions();
        fetchConfig();
    }, [user]);

    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${user?.token}`,
            Accept: 'application/json'
        }
    };
    // Buscar questões do backend
    const fetchQuestions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/quiz`);
            setQuestions(response.data);
        } catch (error) {
            console.error('Erro ao buscar questões:', error);
        }
    };

    const fetchConfig = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/teste`,requestConfig);
            setConfig(response.data);
        } catch (error) {
            console.error('Erro ao buscar questões:', error);
        }
    };

    const listaTestes = async () => {
        const a = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/tests/pending`,
            requestConfig
        );

        if (a.data.pending || hasPermission('logicmanager.classes', user as User) ) {
            setIdTeste(a.data.tests[0].id)
        }
        else {
            navigate("/")
        }
    };

    useEffect(() => {
        listaTestes()
    }, user)

    // Enviar respostas e data para o backend
    const sendForm = async () => {
        try {
            setSubmitting(true);
            const payload = {
                nascimento: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
                fk_user_id: user.id,
                fk_test_id: idTeste,
                school_type: parseInt(schoolType),
                answers: questions.map(q => ({
                    questionId: q.id,
                    selectedOption: answers[q.id] || null
                }))
            };
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/tests/answer`,
                payload,
                requestConfig
            );
            console.log('Respostas enviadas com sucesso:', response.data);
            navigate('/');
        } catch (error) {
            console.error('Erro ao enviar respostas:', error);
        } finally {
            setSubmitting(false);
        }
    };

    const makeQuestion = (question: Question, index: number) => {
        return (
            <div key={question.id} className={styles.question}>
                <div className={styles.questionContainer}>
                    {index + 1 + "°"}
                    
                    <div className={styles.descBox}>
                        <p style={{ textAlign: 'center' }}>
                        {question.desc}
                        </p>
                    </div>

                    {question.img && (
                        <img
                            id={`img${index}`}
                            className={styles.questionImage}
                            src={question.img}
                            alt=''
                        />
                    )}
                    <div className={styles.testeQuestion}>
                        {[1, 2, 3, 4].map(opt => (
                            <label key={opt}>
                                <input
                                    type='radio'
                                    name={`q${question.id}`}
                                    value={opt}
                                    checked={answers[question.id] === opt}
                                    onChange={() =>
                                        setAnswers(prev => ({ ...prev, [question.id]: opt }))
                                    }
                                />
                                {String.fromCharCode(64 + opt)}
                            </label>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className={styles.wrapper}>
            <NavButton
                route='/#'
                direction='left'
                style={{ left: '0.4vw', top: '2vw', zIndex: 20 }}
            />
            <Board wrapperClass={styles.board}>
                <h1 className={styles.title}>Quiz de Lógica Computacional</h1>
                <img className={styles.logo} src={config.logo} alt='Logo' />
                <br />
                  <div className={styles.boxTexto2}>
                <h3 className={styles.desc}>{config.desc}</h3>
</div>
              
                <div className={styles.questionList}>
                    <h2>Insira sua data de nascimento</h2>
                    <h5>(Obrigatório)</h5>
                    <div className={styles.questionario}>
                        <div className={styles.initialFields}>
                            {questions.length > 0 ? (
                                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt">
                                    <DatePicker
                                        className={styles.dateInput}
                                        label="Data de nascimento"
                                        value={fromDate}
                                        onChange={(value: any) => setFromDate(value)}
                                    />
                                </LocalizationProvider>
                            ) : (
                                <Loading />
                            )}

                            <select
                                className={styles.schoolSelect}
                                value={schoolType}
                                onChange={(e) => setSchoolType(e.target.value)}
                            >
                                <option value="1">Escola pública</option>
                                <option value="2">Escola privada</option>
                                <option value="3">Escola mista</option>
                            </select>
                        </div>

                        {questions.length > 0 && questions.map(makeQuestion)}
                    </div>
                </div>
                <br />
                <button
                    className={styles.questionButtonSend}
                    onClick={sendForm}
                    disabled={submitting}
                    title='Confirmar'
                >
                    {submitting ? 'Enviando...' : 'Confirmar respostas'}
                </button>
            </Board>
        </div>
    );
};
